module.exports = __webpack_public_path__ + "img/background-l.34b80138.jpg";